import { compose, withProps, withHandlers, branch, renderNothing } from 'recompose'
import toggle from 'components/common/hoc/toggle'
import shuffle from 'helpers/shuffle'
import { getNextDayTimeData } from './../../../helpers'
import { isMobile } from 'components/common/Media/helpers'
import { ITEMS_LIMIT } from './../constants'
import NextDayTimeTable from './NextDayTimeTable'

const withNextDayTimeBlocks = withProps(({ currentDate,
  dates,
  expanded
}) => {
  if (!currentDate) {
    return
  }

  const { date: nextDay, data } = getNextDayTimeData(dates, currentDate) || {}

  if (!nextDay || !data || data.length === 0) {
    return {
      isApplicable: false
    }
  }

  let timeBlocks = []
  let expandable = false
  if (!isMobile()) {
    timeBlocks = data
  } else {
    expandable = data.length > ITEMS_LIMIT
    timeBlocks = expandable && !expanded ? data.slice(0, ITEMS_LIMIT) : data
  }

  return {
    isApplicable: true,
    nextDay,
    timeBlocks,
    expandable,
    timeSlotsNumber: data.length
  }
})

const withSplitTimeSlots = withProps(({ timeBlocks = []}) => ({
  splitTimeBlocks: shuffle.distributeHorizontally(timeBlocks, 2)
}))

const withHandleNextDaySelect = withHandlers({
  handleNextDaySelect: ({ onNextDaySelect, nextDay }) => () => {
    onNextDaySelect(nextDay)
  }
})

const hideIfNotApplicable = branch(({ isApplicable }) =>
  !isApplicable, renderNothing)

export default compose(
  toggle,
  withNextDayTimeBlocks,
  withSplitTimeSlots,
  hideIfNotApplicable,
  withHandleNextDaySelect
)(NextDayTimeTable)
